'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-dom-server.browser.production.min.js');
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/react-dom/server.browser.js
// module id = 1789
// module chunks = 4 5 15